<template>
  <div class="container activation-options welcome-back">
    <h1 class="section-title">Customer Details</h1>
    <div>
      <div class="subscriber-details">
        <div style="position:relative">
          <span class="details">ENTER CUSTOMER DETAILS</span>
          <a class="clear-input" @click="clearForm">
            Clear
            <i class="fa fa-times"></i>
          </a>
        </div>

        <div class="mb-2">
          These are mandatory fields.
        </div>

        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('first_name') }">
          <input
            type="text"
            v-validate="'required'"
            name="first_name"
            class="form-control"
            v-model="subscriber.first_name"
            data-vv-as="First Name"
            placeholder="First Name"
          />
          <transition name="slide">
            <span class="error-message">{{ errors.first('first_name') }}</span>
          </transition>
        </div>

        <div class="form-group" v-bind:class="{ 'has-errors': errors.has('last_name') }">
          <input
            type="text"
            v-validate="'required'"
            name="last_name"
            class="form-control"
            data-vv-as="Last Name"
            v-model="subscriber.last_name"
            placeholder="Last Name"
          />
          <transition name="slide">
            <span class="error-message">{{ errors.first('last_name') }}</span>
          </transition>
        </div>

        <div class="id-number">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Identification Type?</label>
                <vue-toggle
                  :options="['ID','PASSPORT']"
                  :default="'ID'"
                  :selected.sync="subscriber.id_type"
                  class="row no-gutters"
                >
                  <template slot-scope="{item}">
                    <div class="col">
                      <button
                        type="button"
                        v-on:click="subscriber.id_type = item"
                        class="btn btn-default"
                        v-bind:class="['btn btn-block', subscriber.id_type != null && subscriber.id_type === item ? 'btn-primary': 'btn-outline-primary']"
                      >{{ item }}</button>
                    </div>
                  </template>
                </vue-toggle>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-group">
                <label>{{subscriber.id_type + ' Number'}}</label>
                <the-mask
                  type="text"
                  mask=" ###### #### ### "
                  v-validate="'required|max:13'"
                  name="id_number"
                  class="form-control"
                  v-model="subscriber.id_number"
                  :data-vv-as="subscriber.id_type + ' Number'"
                  :placeholder="subscriber.id_type + ' Number'"
                />
                <transition name="slide">
                  <span
                    class="error-message"
                    v-if="errors.has('id_number')"
                  >{{ errors.first('id_number') }}</span>
                </transition>
              </div>
            </div>
          </div>
        </div>

        <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
        <div class="page-controls mt-3">
          <div class="row no-gutters">            
            <button type="button" class="col btn btn-primary next" v-on:click="validate">
              Save
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "customer-details",
  components: {},
  props: ["subscriber"],
  data: function() {
    return {
      is_loading: false,
      error_message: ""
    };
  },
  methods: {
    cancel() {
      var self = this;
      self.$log.debug("customer details cancel");
      self.$emit("cancel", true);
    },
    validate() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success)
          self.$emit("valid-subscriber", true);
        else self.error_message = "Invalid inputs.";        
      });
    },
    clearForm() {
      var self = this;
      self.$emit("clear-subscriber", true);
    }
  }
};
</script>